export type GameCell = {
	count: number;
	isBomb: boolean;
	isMarked: boolean;
	isHidden: boolean;
	isMistake: boolean;
	x: number;
	y: number;
};

export type GameField = GameCell[][];

export class Game {

	isPlaying: boolean = false;
	isWon: boolean = false;

	cells: GameField = [];

	flagsLeft: number = 0;
	cellsLeft: number = 0;

	constructor(width: number = 15, minesCount?: number) {

		const cellsCount = width * width;
		console.log(`создаем поле: ${width} x ${width} (всего ячеек: ${cellsCount})`);

		if ( ! minesCount) minesCount = Math.round(cellsCount / 2 / 5); // or floor? ceil?
		if ( ! minesCount) throw new Error("Не хватает ячеек для размещения мин");
		if (minesCount == cellsCount) throw new Error("Все ячейки заполнены минами");

		this.cellsLeft = cellsCount;
		this.flagsLeft = minesCount;
		console.log(`общее количество мин: ${minesCount}`);

		this.cells = [];
		for (let x = 0; x < width; x++) {
			this.cells[x] = [];

			for (let y = 0; y < width; y++) {
				this.cells[x][y] = {
					count: 0,
					isBomb: false,
					isMarked: false,
					isHidden: true,
					isMistake: false,
					x,
					y,
				};
			}
		}

		while (minesCount) {
			const x = Math.round(Math.random() * (width - 1));
			const y = Math.round(Math.random() * (width - 1));

			if ( ! this.cells[x][y].isBomb) {
				this.cells[x][y].isBomb = true;
				minesCount--;
			}
		}

		const increaseFieldCount = (x: number, y: number): void => {
			if (x < 0 || x > width - 1 || y < 0 || y > width - 1) return;
			if (this.cells[x][y].isBomb) return;

			this.cells[x][y].count++;
		};

		for (let x = 0; x < width; x++) {
			for (let y = 0; y < width; y++) {

				if (this.cells[x][y].isBomb) {
					increaseFieldCount(x - 1, y);
					increaseFieldCount(x - 1, y - 1);
					increaseFieldCount(x - 1, y + 1);
					increaseFieldCount(x + 1, y);
					increaseFieldCount(x + 1, y - 1);
					increaseFieldCount(x + 1, y + 1);
					increaseFieldCount(x, y + 1);
					increaseFieldCount(x, y - 1);
				}
			}
		}

		this.isPlaying = true;
		console.log('поле создано', this.cells);
	}

	markCell(cell: GameCell): void {
		if ( ! this.isPlaying) return;
		if ( ! cell.isHidden) return;

		if (cell.isMarked) {

			cell.isMarked = false;
			this.cellsLeft++;
			this.flagsLeft++;

		} else {

			if (this.flagsLeft == 0) return;

			cell.isMarked = true;
			this.cellsLeft--;
			this.flagsLeft--;

			this.checkCellsLeft();
		}
	}

	openCell(cell: GameCell): void {
		cell.isHidden = false;
		this.cellsLeft--;
		this.checkCellsLeft();
	}

	checkCellsLeft(): void {
		// победа
		if (this.cellsLeft == 0) {
			this.isPlaying = false;
			this.isWon = true;
		}
	}

	checkCell(cell: GameCell) {
		if ( ! this.isPlaying) return;
		if ( ! cell.isHidden || cell.isMarked) return;

		// в число
		if (cell.count) {
			this.openCell(cell);
			return;
		}

		// в бомбу
		if (cell.isBomb) {
			cell.isHidden = false;
			cell.isMistake = true;

			this.cells.forEach(row => {
				row.forEach(c => {
					if (c.isBomb) {
						c.isHidden = false;
						return;
					}

					if (c.isMarked && ! c.isBomb) {
						c.isMistake = true;
					}
				});
			});

			this.isPlaying = false;
			this.isWon = false;
			return;
		}

		// в пустое место
		const queue = [cell];

		const addFieldForOpen = (x: number, y: number): void => {
			if (x < 0 || x > this.cells.length - 1 || y < 0 || y > this.cells[0].length - 1) {
				return;
			}

			const c = this.cells[x][y];

			if ( ! c.isHidden) return;
			if (queue.includes(c)) return;

			queue.push(c);
		};

		while (queue.length) {
			let c = <GameCell>queue.pop();

			this.openCell(c);

			if (c.isMarked) {
				c.isMarked = false;
				this.flagsLeft++;
			}

			if (c.count == 0) {
				addFieldForOpen(c.x - 1, c.y);
				addFieldForOpen(c.x - 1, c.y - 1);
				addFieldForOpen(c.x - 1, c.y + 1);
				addFieldForOpen(c.x + 1, c.y);
				addFieldForOpen(c.x + 1, c.y - 1);
				addFieldForOpen(c.x + 1, c.y + 1);
				addFieldForOpen(c.x, c.y + 1);
				addFieldForOpen(c.x, c.y - 1);
			}
		}
	}
}
